import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { AILConfig } from './ail-config';
import { IConfigState, IDataState, IState, IUIState, IUploadState } from '../../../interfaces';

export interface IAILConfigStateProps {
  readonly ui: IUIState;
  readonly data: IDataState;
  readonly upload: IUploadState;
  readonly config: IConfigState;
}

export type IAILConfigConnectProps = IAILConfigStateProps & ReactRedux.DispatchProp<Redux.Action>;

export function mapStateToProps(state: IState): IAILConfigStateProps {
  return {
    ui: state.ui,
    data: state.data,
    upload: state.upload,
    config: state.config
  };
}

export const AILConfigContainer: React.ComponentClass
  = ReactRedux.connect(mapStateToProps)(AILConfig);
